import { UnshadowedElement, html } from "../lib/unshadowed.js";

/**
 * User avatar display, with initials / generic fallbacks
 */
export class UserAvatar extends UnshadowedElement {
    static elementName() { return "user-avatar" }

    static properties = {
        avatar: { type: String },
        initials: { type: String },
    };

    render() {
        if (this.avatar) {
            if (this.initials) {
                return html`<figure class='user-avatar'><img src='${this.avatar}' onerror='this.remove()'><span>${this.initials}</span></figure>`;
            } else {
                return html`<figure class='user-avatar'><img src='${this.avatar}' onerror='this.remove()'></figure>`;
            }
        } else if (this.initials) {
            return html`<figure class='user-avatar'><span>${this.initials}</span></figure>`;
        } else {
            return html`<figure class='user-avatar unset'></figure>`;
        }
    }
}
